import { useQuery } from 'react-query'
import { fetcher } from 'src/fetcher'
import { BASE_API_URL } from 'src/globals'
import logger from 'src/logger'

type SubscriptionProduct = {
    stripeProductId: string
    stripeCheckoutUrl: string
    productDisplayName: string
    initialApptBookingUrl: string
}

type SubscriptionProductsResponse = {
    products: SubscriptionProduct[]
}

export function useOpenLoopSubscriptionProduct(): {
    isLoading: boolean
    subscriptionProducts?: SubscriptionProduct[]
} {
    const query = useQuery<SubscriptionProductsResponse>(
        ['openloop-subscription-products'],
        async () => {
            const data = await fetcher(
                `${BASE_API_URL}/awell-api/open-loop/subscription-products?serviceLine=customizedWeightManagement`,
                undefined,
                undefined,
                {
                    customErrorHandler: (res: Response) => {
                        res.text().then(body => {
                            logger.info(
                                `OpenLoop - payment & booking experience`,
                                {
                                    status: res.status,
                                    errorBody: body
                                }
                            )
                        })

                        return new Error('Server returned not-ok')
                    }
                }
            )
            return data
        },
        {
            cacheTime: Infinity
        }
    )

    return {
        isLoading: query.isLoading,
        subscriptionProducts: query.data?.products
    }
}
